import { IconBase } from './IconBase'

type IconCloseProps = React.ComponentProps<'svg'>

export const IconClose = (props: IconCloseProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <circle cx="12" cy="12" r="12" fill="#fff" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.326 17.407a.765.765 0 0 0 1.081-1.081L13.082 12l4.325-4.326a.765.765 0 0 0-1.081-1.081L12 10.918 7.674 6.593a.765.765 0 0 0-1.081 1.081L10.918 12l-4.325 4.326a.765.765 0 0 0 1.081 1.081L12 13.082l4.326 4.325Z"
        fill="#1B1D2A"
      />
    </IconBase>
  )
}
